import api from '../lib/axios';
// --- My directory entries (a contributor manages 0..n) ---
export async function getMyEntries() {
    const { data } = await api.get('/api/pro/entries');
    return data.data;
}
export async function getMyEntry(id) {
    const { data } = await api.get(`/api/pro/entries/${id}`);
    return data.data;
}
export async function updateMyEntry(id, body) {
    const { data } = await api.patch(`/api/pro/entries/${id}`, body);
    return data.data;
}
// --- News of a given entry ---
export async function getMyArticles(entryId) {
    const { data } = await api.get('/api/pro/articles', { params: { entry_id: entryId } });
    return data;
}
export async function createMyArticle(entryId, body) {
    const { data } = await api.post('/api/pro/articles', { ...body, entry_id: entryId });
    return data.data;
}
export async function updateMyArticle(id, body) {
    const { data } = await api.patch(`/api/pro/articles/${id}`, body);
    return data.data;
}
export async function deleteMyArticle(id) {
    await api.delete(`/api/pro/articles/${id}`);
}
export async function resubmitMyArticle(id) {
    await api.patch(`/api/pro/articles/${id}/resubmit`);
}
// --- Events of a given entry ---
export async function getMyEvents(entryId) {
    const { data } = await api.get('/api/pro/events', { params: { entry_id: entryId } });
    return data;
}
export async function createMyEvent(entryId, body) {
    const { data } = await api.post('/api/pro/events', { ...body, entry_id: entryId });
    return data.data;
}
export async function updateMyEvent(id, body) {
    const { data } = await api.patch(`/api/pro/events/${id}`, body);
    return data.data;
}
export async function deleteMyEvent(id) {
    await api.delete(`/api/pro/events/${id}`);
}
export async function resubmitMyEvent(id) {
    await api.patch(`/api/pro/events/${id}/resubmit`);
}
